const Placeholder = ({ componentName }) => (
  <div className="mb-8 rounded border border-red-200 bg-red-100 p-4">
    <p className="text-center text-red-700">
      The component <strong>{componentName}</strong> has not been created yet.
    </p>
  </div>
);

export default Placeholder;
